import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "app/shared/services/api.service";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";

@Component({
  selector: "app-add",
  templateUrl: "./add.component.html",
  styleUrls: ["./add.component.scss"],
})
export class AddComponent implements OnInit {
  @ViewChild("vform") validationForm: FormGroup;

  assetsForm: FormGroup;
  referenceForm: FormGroup;

  fileData: File;
  selectedValue: string[] = [];
  categories = [];
  assetsFormSubmitted: boolean = false;
  type_list = [
    { name: "Portfolio", id: "portfolio" },
    { name: "Product", id: "product" },
    { name: "Project Analysis Document", id: "pad" },
    { name: "Topic Analysis Document", id: "tad" },
    { name: "Portfolio Feature Document", id: "pfd" },
    { name: "Bundle Feature Document", id: "bfd" },
    { name: "Research", id: "research" },
    { name:"Gigs", id:"gigs"}
  ];
  selected_type = null;
  skillId = "6319d3595ab9e462a96cfb06";
  skills_tag_List = [];
  selected_skill = null;

  referenceList = [];
  selectedRef: string[] = [];
  reference_id: any;
  reference_model = {
    refId: "",
    name: "",
    links: "",
    description: "",
    notes: "",
    admin_notes: "",
    IP: "",
  };
  assets_model:any = {
    // references: [],
    name: "",
    // displayname: "",
    // description: "",
    type: '',
    // skills: [],
    notes: "",
    admin_notes: "",
    category: '',
    domain: [],
    skill_keywords: [],
    features_keywords: [],
    projects_keywords: [],
  };
  currentUrl: any;
  assets_id: any;
  updateNotes;
  updateAdminNotes;
  gig_tags_list = []
  selected_gig_tag = null
  isAddSkillKeyword: boolean = false
  isAddfeaturesKeyword: boolean = false
  isAddProjectsKeyword: boolean = false
  domain_list: any = []
  selected_domain = null

  constructor(
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public apiService: ApiService,
    private activateRoute: ActivatedRoute,
    private route: Router,
    private modalService: NgbModal
  ) {
    this.currentUrl = this.activateRoute.snapshot.routeConfig.path;
    this.activateRoute.paramMap.subscribe((params) => {
      this.assets_id = params.get("id");
    });
  }

  ngOnInit() {
    this.getAllCategory()
    this.getSkillTagByCategory();
    this.assetsForm = this.formBuilder.group({
      name: ["", Validators.required],
      displayname: ["", Validators.required],
      description: ["", Validators.required],
      type: ["", Validators.required],
      skills: ["", Validators.required],
      references: ["", Validators.required],
      notes: ["", Validators.required],
      admin_notes: ["", Validators.required],
    });
    this.referenceForm = this.formBuilder.group({
      name: [""],
      links: [""],
      description: [""],
      IP: [""],
      notes: [""],
      admin_notes: [""],
    });
    if (this.currentUrl === "edit/:id") {
      this.getAssetsById();
    }
  }
  getAssetsById() {
    this.apiService.getAssetsById(this.assets_id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.assets_model.name = res?.data[0]?.name;
        // this.assets_model.displayname = res?.data[0]?.displayname;
        // this.assets_model.description = res?.data[0]?.description;
        const { data } = res;
        console.log(data)
        this.selected_type = data[0]?.type
        this.assets_model.type = this.selected_type
        this.assets_model.skill_keywords = data[0].skill_keywords
        this.assets_model.features_keywords = data[0].features_keywords
        this.assets_model.projects_keywords = data[0].projects_keywords
        this.selected_domain = data[0]?.domain?.map(item => item._id)
        this.selected_gig_tag =data[0]?.category?.map(item => item._id)
        this.assets_model.domain = this.selected_domain;
        // this.selected_skill = res?.data[0]?.skills;
        // this.assets_model.skills = this.selected_skill;
        // if (res?.data[0]?.references.length > 0) {
        //   this.referenceList = res?.data[0]?.references?.map((item) => item);
        //   this.selectedRef = this.referenceList?.map((item) => item?._id);
        // }

        this.updateNotes = data[0]?.notes;
        this.updateAdminNotes = data[0]?.admin_notes;
      }
    });
  }
  getTypeId(event: any) {
    this.selected_type;
  }
  getAllCategory() {
    this.apiService.getAllCategory(1,100).subscribe((res: any) => {
      let data = res?.data?.items?.filter((item) => item?.name === 'Gig Keyword')
      let domain_data = res?.data?.items?.filter((item) => item?.name === 'Domain')
      if(data){
        this.getAllGigTags(data[0]._id)
      }
      if (domain_data) {
        this.getAllDomainTags(domain_data[0]._id)
      }
    })
  }
  getAllGigTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.gig_tags_list = res.data;
    });
  }
  getAllDomainTags(id) {
    this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
      this.domain_list = res.data;
    });
  }
  getSkillTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.skillId).subscribe((res: any) => {
      this.skills_tag_List = res.data;
    });
  }
  getSkillTagsId(event: any) {
    this.selected_skill;
  }

  get rf() {
    return this.assetsForm.controls;
  }
  submit() {
    if (this.currentUrl == "add") {
      let body = {
        name: this.assetsForm.controls.name.value,
        // displayname: this.assetsForm.controls.displayname.value,
        // description: this.assetsForm.controls.description.value,
        type: this.selected_type,
        // skills: this.selected_skill,
        // references: this.assets_model.references,
        notes: this.updateNotes,
        admin_notes: this.updateAdminNotes,
        category: this.selected_gig_tag,
        domain: this.selected_domain,
        skill_keywords: this.assets_model.skill_keywords,
        features_keywords: this.assets_model.features_keywords,
        projects_keywords: this.assets_model.projects_keywords
      };
      this.apiService.assetsAdd(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success(res.message);
          this.route.navigate(["/assets/list"]);
        } else {
          this.toastr.error(res.error);
        }
      });
      this.assetsFormSubmitted = true;
      if (this.assetsForm.invalid) {
        return;
      }
    }
    if (this.currentUrl == ("edit/:id")) {
      this.assets_model.type = this.selected_type
      this.assets_model.notes = this.updateNotes;
      this.assets_model.admin_notes = this.updateAdminNotes;
      this.assets_model.domain = this.selected_domain;
      if (this.selected_gig_tag) this.assets_model.category = this.selected_gig_tag
      else{ delete this.assets_model.category}

      this.apiService
        .updateAssets(this.assets_id, this.assets_model)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.toastr.success(res.message);
            this.route.navigate(["/assets/list"]);
          } else {
            this.toastr.error(res.error);
          }
        });
      this.assetsFormSubmitted = true;
      if (this.assetsForm.invalid) {
        return;
      }
    }
  }
  submitRef() {
    this.referenceForm = this.formBuilder.group(this.reference_model);
    this.referenceList.push(this.referenceForm.value);
    this.referenceList = this.referenceList.map((item) => item);
    this.referenceForm.reset(this.reference_model);
    this.modalService.dismissAll();
  }
  getRefId(event) {
    // this.assets_model.references = event;
    // if (!this.assets_id && this.currentUrl == "add") {
    //   this.selectedRef;
    //   this.assets_model.references = event;
    // }
    // if (this.assets_id && this.currentUrl == "edit/:id") {
    //   this.assets_model.references = event;
    //   let data = this.assets_model.references.filter((obj) => !("_id" in obj));
    //   if (data) {
    //     this.assets_model.references = data;
    //     const newValues = event.filter(
    //       (value) =>
    //         !this.assets_model.references.some((obj) => obj._id === value._id)
    //     );
    //     this.assets_model.references.push(...newValues);
    //   }
    // }
  }
  openModal(content) {
    const modalRef = this.modalService.open(content);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      }
    );
  }
  back() {
    this.route.navigate(["/assets/list"]);
  }
  editItem(data, content) {
    this.reference_id = data._id;
    this.reference_model.refId = this.reference_id;
    this.reference_model.name = data.name;
    this.reference_model.links = data.links;
    this.reference_model.description = data.description;
    this.reference_model.notes = data.notes;
    this.reference_model.admin_notes = data.admin_notes;
    this.reference_model.IP = data.IP;
    this.assets_id = data.assets_id;
    const modalRef = this.modalService.open(content);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      }
    );
  }
  updateRef() {
    let body = {
      references: [this.reference_model],
    };
    if (this.reference_id !== "") {
      this.apiService
        .updateAssets(this.assets_id, body)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.toastr.success("Reference update successfully");
            this.getAssetsById();
            this.modalService.dismissAll();
          } else {
            this.toastr.error(res.error);
          }
        });
    }
  }
  deleteRef(password) {
    this.apiService
      .refDelete(this.reference_id, password)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          window.location.reload();
        } else {
          swal.fire({
            icon: "error",
            title: "Error!",
            text: `${res.error}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  // ================== Delete Alert ========================
  confirmDelete(id: any) {
    this.reference_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.deleteRef(result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  // setFocus($event) {
  //   $event.focus();
  //   console.log('=>>>',event)
  // }

  setFocus(event: any) {
    // Logic to handle the editor focus
  }

  notes(event: any) {
    this.updateNotes = event.html;
    this.assets_model.notes = this.updateNotes;
  }
  adminNotes(event: any) {
    this.updateAdminNotes = event.html;
    this.assets_model.admin_notes = this.updateAdminNotes;
  }
  getGigId(event) {
    this.selected_gig_tag
  }
  getDomainId(event) {
    this.selected_domain
  }
  addKeyword(data: string, prop: string) {
    if (!data) return;
    // Split data by commas, trim whitespace, and filter out empty strings
    const keywords = data.split(',')
                          .map(keyword => keyword.trim())
                          .filter(keyword => keyword);  
    // Use switch to handle different properties
    switch (prop) {
      case "skill":
        if (!Array.isArray(this.assets_model.skill_keywords)) {
          this.assets_model.skill_keywords = [];
        }
        this.assets_model.skill_keywords.push(...keywords);
        break;
      case "feature":
        if (!Array.isArray(this.assets_model.features_keywords)) {
          this.assets_model.features_keywords = [];
        }
        this.assets_model.features_keywords.push(...keywords);
        break;
      case "project":
        if (!Array.isArray(this.assets_model.projects_keywords)) {
          this.assets_model.projects_keywords = [];
        }
        this.assets_model.projects_keywords.push(...keywords);
        break;
      default:
        console.error(`Unknown property: ${prop}`);
        break;
    }
  }
  
  
  
removeKeyword(indx: any, prop: any) {
  switch (prop) {
    case "skill":
      this.assets_model.skill_keywords.splice(indx, 1)
      break;
    case "feature":
      this.assets_model.features_keywords.splice(indx, 1)
      break;
    case "project":
      this.assets_model.projects_keywords.splice(indx, 1)
      break;
  }
}

getDuplicateKeywords(): Set<string> {
  const keywordCount = new Map<string, number>();
  const duplicates = new Set<string>();

  // Count occurrences of each keyword
  this.assets_model.skill_keywords.forEach(keyword => {
    keywordCount.set(keyword, (keywordCount.get(keyword) || 0) + 1);
  });

  // Identify duplicates
  keywordCount.forEach((count, keyword) => {
    if (count > 1) {
      duplicates.add(keyword);
    }
  });

  return duplicates;
}

isDuplicate(keyword: string): boolean {
  return this.getDuplicateKeywords().has(keyword);
}
}
